export default __webpack_public_path__ + "static/media/header.6e6c5385.jpg";